<template>
    <div>
        <div class="clearfix row pb-2 mb-2 mt-3 no-margin">


            <div class="col-sm-4 pl-0 leave-search-mobile">
                <div class="custom-search ess-leave-list">
                    <b-input-group class="mb-0">
                        <b-input-group-prepend is-text>
                            <b-icon icon="search"></b-icon>
                        </b-input-group-prepend>
                        <b-form-input type="search" placeholder="Search.." v-model="search" @input="resetPagination()"></b-form-input> {{ this.flg }}
                    </b-input-group>
                </div>
            </div>

        </div>


        <div class="row justify-content-center no-margin employee-table-wrapper">
            <div class="col-sm-12  px-0">
                <b-overlay :show="showoverlay_list" rounded="sm">
                    <table class="table dataTable">
                        <thead>
                            <tr class="table-head">
                                <th class="cursor-pointer" v-for="column in columns" :key="column.name" @click="sortBy(column.name)":class="sortKey === column.name ? (sortOrders[column.name] > 0 ? 'sorting_asc' : 'sorting_desc') : 'sorting'">

                                    <template v-if="column.name !='to' && column.name !='from'">
                                            <label class="custom-label"><span>{{column.label}}</span></label>
                                    </template>
                                    <template v-else>
                                        <label class="custom-label"><span> {{column.label}}</span>
                                            <div class="table-header">
                                                <div class="table sub-header">(YYYY-MM-DD)</div>
                                            </div>
                                        </label>
                                    </template>
                                </th>
                                <th class="text-right" >Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-for="(leave , n) in paginatedData">
                                <tr class="table-row hover-bg" :key="n">
                                    <td class=" ">
                                    <div class="img-holder">
                                        <img v-bind:src="$api_url+'/avatar/'+ leave.company_id + '/' + leave.employee_pic" class="img-fluid img-thumbnail employee-avatar mr-2" />
                                    </div>
                                    <div class="name-holder">
                                        {{leave.employee_name}}<br />
                                        <span class="txt-alt">{{leave.employee_code}}</span>
                                    </div>
                                    </td>
                                    <td class="">
                                    {{leave.jobposition}}
                                    </td>
                                    <td class="">
                                    {{leave.department}}
                                    </td>
                                    <td class="">
                                    <b-icon :icon="leave.icon || 'calendar'" class="mr-2 text-primary" font-scale="1.1"></b-icon>
                                    {{leave.leave_type}}
                                    </td>
                                    <td class="">
                                    {{leave.from}}
                                    </td>
                                    <td class="">
                                    {{ leave.to }}
                                    </td>
                                    <td class="">

                                    <template v-if="leave.leave_day == 0">
                                        {{leave.number_of_days}}
                                        <span v-if="leave.number_of_days > 1">days</span>
                                        <span v-else>day</span>
                                    </template>
                                    <template v-else-if="leave.leave_day == 1">First Half</template>
                                    <template v-else-if="leave.leave_day == 2">Second Half</template>
                                    </td>
                                    <td v-if="roster == 1">
                                    <template v-if="leave.shifts && Object.keys(leave.shifts).length > 0">
                                        <div v-for="(shifts_arr, date) in leave.shifts" :key="date" class="d-inline">
                                        <small
                                            v-for="shift in shifts_arr"
                                            :key="shift.id || shift.code || shift.name"
                                            v-b-tooltip.hover
                                            :title="`Date: ${date} - Shift: ${shift.name} : ${moment(shift.start_time, 'hh:mm A').format('hh:mm A')} - ${moment(shift.end_time, 'hh:mm A').format('hh:mm A')}`"
                                            class="border rounded p-1 mr-1"
                                            :style="`background-color:${(shift.color || '#000') + '22'}; color:${shift.color || '#000'};`"
                                        >
                                            {{ shift.code }}
                                        </small>
                                        </div>
                                    </template>
                                    <span v-else>N/A</span>
                                    </td>
                                    <td class="leave-reason-wrapper w-200">
                                    {{leave.reason}} <br />
                                    <b-link v-if="leave.attachment" @click="downloadFileContent('/avatar/'+ leave.company_id + '/leaves/' + leave.attachment)"><img :src="$api_url+'/images/download_image.png'"  class="" /> </b-link>
                                    </td>

                                    <td class="">
                                    <span class="leave-status" v-if="leave.status == 'Approved'"><i class="far fa-dot-circle mr-1 text-success"></i>{{leave.status}}</span>
                                    <span class="leave-status" v-else-if="leave.status == 'Applied'"><i class="far fa-dot-circle mr-1 text-primary"></i>Applied</span>
                                    <span class="leave-status" v-else-if="leave.status == 'Declined'"><i class="far fa-dot-circle mr-1 text-danger"></i>{{leave.status}}</span>
                                    </td>
                                    <td class="">
                                    {{leave.updated_by}}
                                    </td>

                                    <td class="text-right">
                                    <a id="actionDropdown" class="dropdown-toggle clearfix action-dropdown-toggle" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><b-icon icon="three-dots-vertical"></b-icon></a>
                                    <div class="dropdown-menu action-dropdown-menu" aria-labelledby="actionDropdown">
                                        <b-button-toolbar class="">
                                        <b-button-group class="mr-0">
                                            <b-button class="rounded delete-btn" title="Delete" @click="checkLimits(leave.employee_id)">
                                            <b-icon icon="check-circle" class="mr-2" aria-hidden="true"></b-icon>Check Limits
                                            </b-button>
                                        </b-button-group>
                                        </b-button-toolbar>
                                    </div>
                                    </td>
                                </tr>
                                </template>
                        </tbody>
                    </table>


                    <div v-if="paginatedData.length == 0" class="list-no-data">
                        No records found.
                    </div>
                    <div v-else class="">
                        <div class="clearfix mt-2 mb-4">
                            <ul class="pagination b-pagination float-left mb-0 mt-1">
                                <li class="page-item disabled m-2">View</li>
                                <li class="page-item disabled"><b-form-select v-model="temp_length" :options="length_options" @change="setFirstPage()"></b-form-select></li>
                                <li class="page-item disabled m-2">per page. Total {{people}} records found.</li>
                            </ul>
                            <b-pagination-nav class="float-right mt-1" v-model="pagination.currentPage" :number-of-pages="pagination.pages" prev-text="Previous" next-text="Next" base-url="#" first-number last-number ></b-pagination-nav>

                        </div>
                    </div>
                </b-overlay>
            </div>
        </div>

      <b-modal id="employeeLeavesLimit" hide-footer title="Allowed Leaves" dialog-class="w-1000">
        <div class="row mt-4">

          <div class="col-sm-12 table-responsive">
            <table class="table">
              <thead>
              <tr class="table-head">
                <th>Type</th>
                <th>Leaves Allowed</th>
                <th v-if="carry == 1">Carried</th>
                <th>Available</th>
                <th>Applied</th>
                <th>Enjoyed</th>
                <th>Deducted</th>
                <th v-if="encash == 1">Encashed</th>
                <th>Remaining</th>
              </tr>
              </thead>
              <tbody>
              <tr class="table-row hover-bg" v-for="leave_type in leave_available" :key="leave_type.id">
                <td>
                  <b-icon :icon="leave_type.icon || 'calendar'" class="mr-2 text-primary" font-scale="1.1"></b-icon>
                  {{leave_type.leave_title}}
                </td>

                <td>{{leave_type.allowed}} {{ getBasisText(leave_type.basis)  }}</td>

                <td v-if="carry == 1">{{leave_type.carried}} {{ getBasisText(leave_type.basis)  }}</td>
                <td>{{leave_type.leave_days}} {{ getBasisText(leave_type.basis)  }}</td>
                <td>{{leave_type.applied}} {{ getBasisText(leave_type.basis)  }}</td>
                <td>{{leave_type.enjoyed}} {{ getBasisText(leave_type.basis)  }}</td>
                <td>{{leave_type.deducted}} {{ getBasisText(leave_type.basis)  }}</td>
                <td v-if="encash == 1">{{leave_type.encashed}} {{ getBasisText(leave_type.basis)  }}</td>
                <td>{{leave_type.remaining}} {{ getBasisText(leave_type.basis)  }}</td>
              </tr>
              </tbody>
            </table>

          </div>

        </div>
      </b-modal>
    </div>
</template>
<script>
    import moment from 'moment'
    export default{

        mounted() {

        },
        props: [ 'flg' ],
        components: {},
        data(){
            /** Sohel Code Starts Here */
            let sortOrders = {};
            let columns = [
                {label: 'Employee', name: 'employee_name' },
                {label: 'Job Position', name: 'employee_code' },
                {label: 'Department', name: 'department' },
                {label: 'Leave Category', name: 'leave_type'},
                {label: 'From', name: 'from'},
                {label: 'To', name: 'to'},
                {label: 'No. of Days/Shifts', name: 'number_of_days'},
                {label: 'Shift(s)', name: 'shifts'},
                {label: 'Reason', name: 'reason'},
                {label: 'Status', name: 'status'},
                {label: 'Updated By', name: 'updated_by'},
            ];
            columns.forEach((column) => {sortOrders[column.name] = -1;});
            /** Sohel Code Ends Here */

            const now = new Date();
            const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());

            const minDate = new Date(today);
            minDate.setMonth(minDate.getMonth());
            minDate.setDate(minDate.getDate());
            const startdate = minDate;
            var startDate = '';
            var endDate = '';
            //var today = new Date();
            if ((today.getMonth() + 1) <= 6)
            {
                startDate = (today.getFullYear() - 1) + '-07-1';
                endDate = (today.getFullYear()) + '-06-30';
            }
            else
            {
                startDate = (today.getFullYear()) + '-07-1';
                endDate = (today.getFullYear() + 1) + '-06-30';
            }

            return {
                depertments:[],
                search_by_id:{department_id:0,jobposition_id:0, leave_type_id:0 , flg_status:0},
                startDate : startDate,
                endDate : endDate,
                min: minDate,
                day_one: moment(String(startdate)).format('YYYY-MM-DD') ,
                day_two: moment(String(startdate)).format('YYYY-MM-DD') ,
                week_holidays : [6],
                all_week_holidays : [6],
                week_start_day : 7,
                holidays_date_arr : [],
                leavetypes: [],
                flg_status : [
                            { text: 'Applied', value: '0' },
                            { text: 'Approved', value: '1' },
                            { text: 'Declined', value: '2' },
                        ],

                /** Sohel Code Starts Here */
                columns: columns,
                sortKey: 'employee_name',
                sortOrders: sortOrders,
                /** Sohel Code Ends Here */

                leaves:[],
                carry: 0,
                encash: 0,

                showoverlay:false,
                showoverlay_list:false,
                movenext : false,

                errormsg:[],
                fdata: {  },
                roster: 0,

                search:'',
                length: 10,
                pagination: {currentPage: 1, pages:1},
                temp_length: 10,
                length_options: [],
                people:0,

                ce : true,
                employee_id : 0,
                leave_available: [],

                approved_leaves_today : 0,
                pending_leaves_today : 0,
                pending_leaves_fiscal_year : 0,


                tmp_leave_type_id : 0,
                tmp_flg_status : 0,
                tmp_from : '',
                tmp_to : '',


                start_date: null,
                end_date: null,
                lv : [],
                this_month_holidays : [],
                this_month : 1,
                this_year : 2020,
                weekly_holidays : [6],
                first_day_of_week : 7,
                total_working_day : 0,
                total_weekends : 0,
                total_holidays : 0,
                weekend_color_code : '#aaaaaa',
                holiday_color_code : '#aaaaaa',

            }
        },
        methods:{
          moment,
          getBasisText(flg) {
            if (flg == 1) {
                return 'Shifts';
            }
            return 'Days';
            },
          deleteLeave: function(employee_id , leave_type_id , flg_status , from , to)
          {
            let formData = new FormData();
            formData.append('employee_id' , employee_id);
            formData.append('leave_type_id' , leave_type_id);
            formData.append('from' , from);
            formData.append('to' , to);
            formData.append('flg_status' , flg_status);



            axios.post(this.$api_url+'/front/leave-attendance/leave/delete/range', formData)
                .then(function (response)
                {
                  this.$bvToast.toast('Deleted!', {
                    title: `Success`,
                    variant: 'success',
                    solid: true
                  });


                  this.getLeaves();
                  this.getApprovePendingLeavesToday();

                }.bind(this))
                .catch(function (error)
                {
                  currentObj.showoverlay = false;
                  currentObj.serverError(error);
                });
          },
            checkLimits(employee_id){
              axios.get(this.$api_url + '/front/leave-attendance/employee/leaves', {
                params: {
                  employee_id:employee_id
                }
              }).then(response => {
                this.leave_available = response.data.available;
                this.$bvModal.show('employeeLeavesLimit');
              });
            },
            getLeaves: function()
            {
                //this.showoverlay_list = true;
                if(!this.checkNet()) return false;

                let currentObj = this;
                axios.get(this.$api_url+'/front/leave-attendance/employees/leaves/fiscalyear?approver=1' , {
                    params: {

                    }
                }).then(function(response){

                    this.leaves = response.data.leaves;





                }.bind(this)).catch(function (error){ currentObj.serverError(error);});
            },




            getDepertments: function(){
              axios.get(this.$api_url+'/front/department/list')
              .then(function (response) {
                 this.depertments = response.data;
              }.bind(this));

            },

            getDisabledDates:function()
            {
                axios.get(this.$api_url+'/front/leave-attendance/holidays/details').then(function(response){

                    if(response.data.length != 0)                    {
                        this.all_week_holidays = response.data.report.week_holidays;
                        this.week_start_day =  response.data.report.week_start_day;
                        this.holidays_date_arr = response.data.report.holidays_date_arr.split(',').map(function(item){ return item;});
                    }
                }.bind(this));
            },
            getLeaveTypes: function()
            {
                if(!this.checkNet()) return false;
                axios.get(this.$api_url+'/front/leave-attendance/leave/types' , {

                }).then(function(response){

                    this.leavetypes = response.data;
                }.bind(this));
            },


            getCompanyLeaveSettings:function()
            {
                if(!this.checkNet()) return false;
                axios.get(this.$api_url+'/front/leave-attendance/company/leave/settings').then(function(response){

                    if(response.data.length != 0)
                    {
                    this.roster = response.data.roster;
                    this.carry = response.data.carry;
                    this.encash = response.data.encash;

                    this.columns = this.columns.map(column => ({ ...column }));

                    this.columns = this.columns.map(column => {
                        if (column.name == 'number_of_days') {
                        return {
                            ...column,
                            label: 'No. of Days' + (this.roster == 1 ? '/Shifts' : '')
                        };
                        }

                        return column;
                    });

                    if (this.roster != 1) {
                        this.columns = this.columns.filter(column => column.name != 'shifts');
                    }
                    }
                }.bind(this));
            },

        },
        created: function(){

            this.getDepertments();
            this.getLeaveTypes();
            this.getDisabledDates();
            this.getCompanyLeaveSettings();
            this.getLeaves();
        },
        computed:
        {
            filteredData()
            {
                let filtered_list = this.leaves;
                this.people = this.leaves.length;
                this.length_options = [{ value: 10, text: "10" },{ value: 20, text: "20" },
                                                    { value: 50, text: "50" },
                                                    { value: 100, text: "100" },
                                                    { value: 200, text: "200" },
                                                    { value: 500, text: "500" },
                                                    { value: this.leaves.length, text: "All" }];
                if (this.search)
                {

                    filtered_list = filtered_list.filter((row) => {return Object.keys(row).some((key) => {return String(row[key]).toLowerCase().indexOf(this.search.toLowerCase()) > -1;})});

                    if(filtered_list.length == 0)
                        this.blankmsg = "Nothing found.";
                }

                let sortKey = this.sortKey;
                let order = this.sortOrders[sortKey] || 1;
                if (sortKey)
                {
                    filtered_list = filtered_list.slice().sort((a, b) => {let index = this.getIndex(this.columns, 'name', sortKey);
                            a = String(a[sortKey]).toLowerCase();
                            b = String(b[sortKey]).toLowerCase();
                            if (this.columns[index].type && this.columns[index].type === 'date')
                            {
                                return (a === b ? 0 : new Date(a).getTime() > new Date(b).getTime() ? 1 : -1) * order;
                            }
                            else if (this.columns[index].type && this.columns[index].type === 'number')
                            {
                                return (+a === +b ? 0 : +a > +b ? 1 : -1) * order;
                            }
                            else
                            {
                                return (a === b ? 0 : a > b ? 1 : -1) * order;
                            }
                        }
                    );
                }

                return filtered_list;
            },
            paginatedData()
            {
                return this.paginate(this.filteredData, this.length, this.pagination.currentPage);
            },

            fetchStartWeekday()
            {
                return this.week_start_day;
            },
        }
    }
</script>
